// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a3b14dab","686":"37ad55eb","722":"db2d4b92"}[chunkId] + ".chunk.js";
};